import React, { useState } from 'react';
import { Modal, Row, Button } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';//props传参检查库
import trans from './translation';
import { Config } from '../../public/js/config';

import './confirmFrame.css';

/**
 * 确认弹框组件
 * props传参如下
 * @param content:消息内容（不传默认为"删除"）
 * @param close:关闭弹框时修改弹框显示状态的回调方法
 */
const ConfirmFrame = (props) => {

    const content = useState(props?.content);
    const tipText = useState(props?.tipText);
    const deleteTipText = useState(props?.deleteTipText);

    const closeFrame = (state) => {
        props.close(state);
    }

    return (
        <Row>
            <Modal
                closable={false}
                className="confirmFrameAlign"
                width={!props?.content ? "400px" : "600px"}
                visible={true}
                onCancel={() => {closeFrame(false)}}
                footer={[
                    <Button className="sysBtn btnBlue" key='save' type="primary" onClick={() => closeFrame(true)} icon={<CheckCircleOutlined />}>{trans.save[Config.backLang]}</Button>,
                    <Button key='cancel' className="sysBtn" onClick={() => closeFrame(false)} icon={<CloseCircleOutlined />}>{trans.cancel[Config.backLang]}</Button>
                ]}
            >
                { deleteTipText &&
                    <div className="confirmFrameText">{deleteTipText}</div>
                }
                { tipText &&
                    <div className="confirmFrameText">{tipText}</div>
                }
                { content &&
                    <div className="confirmFrameCenter">{content}</div>
                }
            </Modal>
        </Row>
    )
}

/**
 * props参数检查
 */
ConfirmFrame.propTypes = {
    type: PropTypes.string
    ,content: PropTypes.string
    ,close: PropTypes.func.isRequired
    ,tipText: PropTypes.string
    ,deleteTipText: PropTypes.string
};

export default ConfirmFrame;